export type PaygServiceId =
  | "geoip"
  | "proxy"
  | "asnlookup"
  | "binlookup"
  | "paymentfraud"
  | "ibanvalidation"
  | "profanitydetection"
  | "emailvalidation"
  | "phonevalidation"
  | "countrylookup"
  | "domainlookup";

export const paygServiceOrder: PaygServiceId[] = [
  "geoip",
  "proxy",
  "asnlookup",
  "binlookup",
  "paymentfraud",
  "ibanvalidation",
  "profanitydetection",
  "emailvalidation",
  "phonevalidation",
  "countrylookup",
  "domainlookup",
];

/** Per-request unit prices (USD). Source: legacy Greip Variables defaults. */
export const paygUnitPrices: Record<PaygServiceId, number> = {
  geoip: 0.0001,
  proxy: 0.00026,
  asnlookup: 0.0064,
  binlookup: 0.0011,
  paymentfraud: 0.0064,
  ibanvalidation: 0.0054,
  profanitydetection: 0.00007,
  emailvalidation: 0.00041,
  phonevalidation: 0.0012,
  countrylookup: 0.10004,
  domainlookup: 0.005,
};

export const paygDefaultRequests: Record<PaygServiceId, number> = {
  geoip: 150_000,
  proxy: 100_000,
  asnlookup: 0,
  binlookup: 0,
  paymentfraud: 0,
  ibanvalidation: 0,
  profanitydetection: 0,
  emailvalidation: 0,
  phonevalidation: 0,
  countrylookup: 0,
  domainlookup: 0,
};

export const paygSliderBounds = {
  min: 0,
  max: 10_000_000,
  step: 10_000,
} as const;
